import Model from '@/models/Model'

export default class ANotReception extends Model {
    resource() {
        return 'not_reception'
    }
}